/* eslint import/no-webpack-loader-syntax: off */

import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Link, NavLink } from 'react-router-dom';

import { Theme } from '../../config/theme';

import CompanyLogo from '../CompanyLogo';
import Button from '../Button';

export default class UnauthenticatedHeader extends Component {
  constructor(props) {
    super(props);

    this.openLoginHandler = this.props.openLoginHandler.bind(this);
  }

  render() {
    return (
      <div className={css(styles.container) + ' DashboardHeader'}>
        <div className={css(styles.header_container)}>
          <div className={css(styles.header)}>
            <div className={css(styles.logo_container)}>
              <CompanyLogo styles={styles.company_logo} />
            </div>
            <div className={css(styles.buttons)}>
              <Link
                to="/"
                className={css(styles.login_link)}
              >
                <div>How It Works</div>
              </Link>
              <Link
                to="/story"
                className={css(styles.login_link)}
              >
                <div>Our Story</div>
              </Link>
              <div
                className={css(styles.login_link)}
                onClick={this.openLoginHandler}
                role="link"
                tabIndex={0}
              >
                <div>Login</div>
              </div>
              <NavLink to="/join">
                <Button title="Join the collective" />
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UnauthenticatedHeader.propTypes = {
  openLoginHandler: PropTypes.func.isRequired,
};

const styles = StyleSheet.create({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: '100',
    display: 'flex',
    width: '100vw',
    height: Theme.navigation.height,
    backgroundColor: Theme.white,
  },
  header_container: {
    position: 'relative',
    display: 'flex',
    margin: '0 auto',
    width: Theme.container_width,
    alignItems: 'center',
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
  },
  logo_container: {
    width: 180,
  },
  company_logo: {
    position: 'absolute',
    top: 10,
    left: 0,
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',

    [Theme.mobile_query]: {
      display: 'none',
    },
  },
  login_link: {
    cursor: 'pointer',
    textTransform: 'uppercase',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    fontSize: Theme.font_size_secondary,
    letterSpacing: 1,
    color: Theme.offblack,
    transition: 'all 160ms ease-in-out',
    marginRight: 40,
    ':hover': {
      color: Theme.primary,
    },
  },
  nav_item: {
    position: 'relative',
    textTransform: 'uppercase',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    fontSize: Theme.font_size_secondary,
    letterSpacing: 1,
    color: Theme.dark_grey,
    transition: 'all 160ms ease-in-out',
    marginLeft: 25,
    marginRight: 25,
    ':hover': {
      color: Theme.primary,
    },
  },
  nav_item_disabled: {
    color: Theme.grey,
    cursor: 'not-allowed',
    ':hover': {
      color: Theme.grey,
    },
  },
  nav_item_active: {
    color: Theme.primary,
  },
  coming_soon: {
    position: 'absolute',
    marginLeft: -10,
  },
});



// WEBPACK FOOTER //
// ./src/components/UnauthenticatedHeader/index.js